// export default AppRouter;
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useAuth } from "../auth/authContext";
import Axios from "../axios";
import Login from "../components/login";
import Dashboard from "../components/dashboard";
import ArrivalList from "../components/arrivalsList";
import BookingList from "../components/bookingList";
import DailyTransaction from "../components/dailyTransaction";
import ProtectedRoute from "./protectedRoutes";
import UserManagement from "../components/user";
import FAQManagement from "../components/faq";
import TripListing from "../components/tripListing";
import NewsRoom from "../components/newsRoom";
import Subscription from "../components/subscription";
import SliceAndDice from "../components/sliceAndDice";
import PrivacyAndPolicy from "../components/privacyAndPolicy";
import TermsAndCondition from "../components/termsAndCondition";
import Flodesk from "../components/floDesk";
import RoleManagement from "../components/roleManagement";
import SetPassword from "../components/setPassword";
import FeaturedHotels from "../components/featuredHotels";
import Affiliates from "../components/affiliates";
import Market from "../components/market";
import AboutUs from "../components/aboutUs";
// Replace with your actual staticNavData
const staticNavData = [
  { id: 1, text: "Dashboard", link: "/dashboard" },
  { id: 18, text: "About Us", link: "/aboutus" },
  { id: 2, text: "ArrivalList", link: "/arrival-list" },
  { id: 3, text: "BookingList", link: "/booking-list" },
  { id: 4, text: "DailyTransaction", link: "/daily-transaction" },
  { id: 5, text: "UserManagement", link: "/user-management" },
  { id: 6, text: "FAQManagement", link: "/faq-management" },
  { id: 7, text: "TripListing", link: "/trip-listing" },
  { id: 8, text: "NewsRoom", link: "/news-room" },
  { id: 9, text: "Subscription", link: "/subscription" },
  { id: 10, text: "SliceAndDice", link: "/slice-and-dice" },
  { id: 11, text: "PrivacyAndPolicy", link: "/privacy-and-policy" },
  { id: 12, text: "TermsAndCondition", link: "/terms-and-condition" },
  { id: 13, text: "Flodesk", link: "/flo-desk" },
  { id: 14, text: "RoleManagement", link: "/role-access" },
  { id: 15, text: "FeaturedHotels", link: "/feature-hotels" },
  { id: 16, text: "Affiliates", link: "/affiliates" },
  { id: 17, text: "Market", link: "/market" },
];

const AppRouter = () => {
  const { logout } = useAuth();
  const [roles, setRoles] = useState([]);
  const [navData, setNavData] = useState([]);
  const role = localStorage.getItem("role");

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const resp = await Axios.post(
          `${process.env.REACT_APP_BACKEND}get-roles`,
          { page: 1, searchChar: "" }
        );
        setRoles(resp?.data?.data || []);
      } catch (err) {
        console.error("Error fetching roles", err);
      }
    };
    fetchRoles();
  }, []);
  useEffect(() => {
    if (roles.length > 0 && role) {
      // Find the role object for the current user role
      const userRole = roles.find(
        (r) => r.role.trim().toLowerCase() === role.trim().toLowerCase()
      );

      if (userRole) {
        // Filter the navigation data based on permissions
        const filteredNavData = staticNavData.filter((navItem) => {
          const permission = userRole.permissions.find(
            (perm) =>
              normalizeString(perm.page) === normalizeString(navItem.text)
          );
          // Include the item if the user has read or write permission
          return permission?.read || permission?.write;
        });

        // Set the filtered navigation data
        setNavData(filteredNavData);
      }
    }
  }, [roles, role, staticNavData]);

  // Helper function to normalize strings
  const normalizeString = (str) => str.replace(/[\s&]+/g, "").toLowerCase();

  const components = {
    Dashboard,
    ArrivalList,
    BookingList,
    DailyTransaction,
    UserManagement,
    FAQManagement,
    TripListing,
    NewsRoom,
    Subscription,
    SliceAndDice,
    PrivacyAndPolicy,
    TermsAndCondition,
    Flodesk,
    RoleManagement,
    FeaturedHotels,
    Affiliates,
    Market,
    AboutUs,
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/set-password" element={<SetPassword />} />

        <Route element={<ProtectedRoute navData={navData} />}>
          {navData.map((navItem) => {
            const componentKey = navItem.text.replace(/\s/g, "");
            const Component = components[componentKey];
            return (
              <Route
                key={navItem.id}
                path={navItem.link}
                element={<Component />}
              />
            );
          })}
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
